import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { CrossIcon, StyledArrowIcon } from '@westwing/ui-kit/Icons/StyledIcons';
import { BellaTestIds } from '../../../common/qaIds';
import {
    RightButton,
    LeftButton,
    StyledTitleContainer,
    TitlePosition,
    StyledHeaderContainer,
} from './GenericFlyout/Header';

const BackButton = styled(LeftButton)`
    padding-top: 5px;
`;

const CloseButton = styled(RightButton)`
    align-items: center;
    display: flex;
    height: 30px;
    justify-content: center;
    width: 30px;
`;

const BackArrow = styled(BackButton)`
    align-items: center;
    display: flex;
    height: 30px;
    justify-content: center;
    width: 30px;
`;

const StyledTitle = styled(StyledTitleContainer)`
    min-height: 0;
`;

type Props = {
    title: string;
    hideCloseIcon?: boolean;
    shouldHaveBackBtn: boolean;
    handleCloseBtnClick: () => void;
    handleBackBtnClick?: () => void;
};

const CustomFlyoutHeader = ({
    title,
    shouldHaveBackBtn,
    handleCloseBtnClick,
    handleBackBtnClick = () => {},
    hideCloseIcon,
}: Props): ReactElement => (
    <StyledHeaderContainer data-testid={BellaTestIds.NFHMenuHeader}>
        {shouldHaveBackBtn && (
            <BackArrow type="button" onClick={handleBackBtnClick} data-testid={BellaTestIds.NFHBackBtn}>
                <StyledArrowIcon size={9} />
            </BackArrow>
        )}
        <StyledTitle position={TitlePosition.CENTER} data-testid={BellaTestIds.NFHMenuTitle}>
            {title}
        </StyledTitle>
        {!hideCloseIcon && (
            <CloseButton type="button" onClick={handleCloseBtnClick} data-testid={BellaTestIds.NFHRightCloseBtn}>
                <CrossIcon width={15} height={15} strokeWidth={5} />
            </CloseButton>
        )}
    </StyledHeaderContainer>
);
export default CustomFlyoutHeader;
